'use client';

import Link from 'next/link';
import { useLanguage } from '@/hooks/use-language';

export default function TermsPage() {
  const { lang } = useLanguage();
  const isAr = lang === 'ar';

  return (
    <div className="min-h-screen bg-background text-white" dir={isAr ? 'rtl' : 'ltr'}>
      <header className="sticky top-0 z-50 border-b border-zinc-900 bg-background/80 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center">
          <Link href="/" className="text-lg font-bold">Momira</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12 space-y-8 text-sm leading-relaxed text-zinc-300">
        <h1 className="text-3xl font-bold text-white">{isAr ? 'شروط الاستخدام' : 'Terms of Use'}</h1>
        <p className="text-zinc-500 text-xs">{isAr ? 'آخر تحديث: مايو 2025' : 'Last updated: May 2025'}</p>

        {isAr ? (
          <>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">القبول بالشروط</h2>
              <p>باستخدام منصة Momira، فأنت توافق على هذه الشروط. إذا كنت لا توافق، يرجى عدم استخدام المنصة.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">منع المحتوى المخالف</h2>
              <p>يُمنع رفع أي محتوى مخالف للقوانين، أو يحتوي على صور غير لائقة، أو مسروق، أو يؤذي الآخرين. Momira تحتفظ بحق حذف أي محتوى مخالف فورًا.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">مسؤولية صاحب المناسبة</h2>
              <p>صاحب المناسبة مسؤول عن مشاركة الرابط مع الضيوف المناسبين، وعن مراجعة الصور والموافقة عليها. أنت مسؤول عن ضمان حصولك على موافقة الضيوف لرفع صورهم.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">حدود الاستخدام</h2>
              <p>حدود التخزين والصور والفيديوهات تعتمد على الباقة المختارة. تجاوز الحد قد يوقف الرفع تلقائيًا.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">سياسة الاسترجاع</h2>
              <p>لا يوجد استرجاع بعد إنشاء المناسبة والبدء في الرفع. في حالة مشاكل تقنية من طرفنا، يُدرس كل طلب بشكل مستقل.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">تعليق الخدمة</h2>
              <p>نحتفظ بحق تعليق أو إنهاء الحسابات التي تنتهك هذه الشروط.</p>
            </section>
          </>
        ) : (
          <>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">Acceptance of Terms</h2>
              <p>By using Momira, you agree to these terms. If you disagree, please do not use the platform.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">Prohibited Content</h2>
              <p>Uploading illegal, inappropriate, stolen, or harmful content is strictly prohibited. Momira reserves the right to delete any violating content immediately.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">Host Responsibility</h2>
              <p>The event host is responsible for sharing the link with appropriate guests and for reviewing and approving photos. You are responsible for ensuring guest consent for sharing their images.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">Usage Limits</h2>
              <p>Storage, photo, and video limits depend on the selected plan. Exceeding limits may automatically pause uploads.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">Refund Policy</h2>
              <p>No refunds after an event is created and uploads have started. Technical issues on our end are evaluated on a case-by-case basis.</p>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-white mb-2">Service Suspension</h2>
              <p>We reserve the right to suspend or terminate accounts that violate these terms.</p>
            </section>
          </>
        )}
      </main>

      <footer className="py-8 px-6 border-t border-zinc-900 text-center text-sm text-zinc-500">
        <div className="flex flex-wrap justify-center gap-4">
          <Link href="/privacy" className="hover:text-zinc-300">{isAr ? 'الخصوصية' : 'Privacy'}</Link>
          <Link href="/terms" className="hover:text-zinc-300">{isAr ? 'الشروط' : 'Terms'}</Link>
          <Link href="/contact" className="hover:text-zinc-300">{isAr ? 'تواصل معنا' : 'Contact'}</Link>
        </div>
      </footer>
    </div>
  );
}
